const SkeletonRoom = () => {
    return (
        <div className="rounded-md grow h-full grid grid-rows-10 grid-flow-col overflow-hidden drop-shadow-md aspect-[5/6]">
            <div className="row-span-6 relative w-full h-full p-4 bg-gray-200 animate-pulse"></div>
            <div className="row-span-4 p-4 grid grid-rows-3 grid-flow-col bg-gray-100 gap-3">
                <div className="flex flex-row align-center">
                    <div className="basis-3/4 bg-gray-300 rounded-md animate-pulse"></div>
                </div>
                <div className="flex flex-col content-center bg-gray-300 rounded-md animate-pulse"></div>
                <div className="flex flex-row justify-between items-end bg-gray-300 rounded-md animate-pulse"></div>
            </div>
        </div>
    );
};

export default SkeletonRoom;
